import Container from "./container/Container";
import { LocalProvider } from './context/LocalContext';
import './assets/style.css'
import { AdminProvider } from "./context/AdminContext";
import { BlogProvider } from "./context/BlogContext";
import { Helmet, HelmetProvider } from '@vuer-ai/react-helmet-async';
import { MessageProvider } from "./context/MessageContext";
import { ServiceProvider } from "./context/ServiceContext";

function App() {
  return (
    <div className="App">
      <LocalProvider >
        <ServiceProvider>
        <AdminProvider >
        <MessageProvider >
          <BlogProvider >
        <HelmetProvider>
      <Container />
      </HelmetProvider>
      </BlogProvider>
      </MessageProvider>
      </AdminProvider>
      </ServiceProvider>
      </LocalProvider>
    </div>
  );
}

export default App;
